var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadena(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.981,
    height: 19.478,
    viewBox: "0 0 16.981 19.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1397",
    "data-name": "Groupe 1397",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_809",
    "data-name": "Groupe 809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 14.981,
    height: 12.521,
    rx: 5,
    transform: "translate(0 4.958)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_645",
    "data-name": "Trac\\xE9 645",
    d: "M3057.845,4201.1v-1.23a3.728,3.728,0,0,1,3.727-3.728h0a3.728,3.728,0,0,1,3.727,3.728v1.23",
    transform: "translate(-3054.082 -4196.146)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_409",
    "data-name": "Ligne 409",
    y2: 2.81,
    transform: "translate(7.491 9.696)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadena);
export default __webpack_public_path__ + "static/media/cadena.57e31f6e964b461250b0b429e4886015.svg";
export { ForwardRef as ReactComponent };